export default __webpack_public_path__ + "static/media/users_openapi.3102903d.yaml";